import {Component, OnInit, TemplateRef} from '@angular/core';
import {BlockStatementAbstractComponent} from '../block-statement-abstract.component';
import {AddedExtrasReward} from '../../types/added.extras.type';
import {TimeReward} from '../../types/time.reward.type';

@Component({
    selector: 'core-added-extras',
    templateUrl: './block-added-extras.component.html',
    standalone: false
})
export class BlockAddedExtrasComponent extends BlockStatementAbstractComponent implements OnInit {
    categories: any;
    addedExtraRewards!: AddedExtrasReward;
    isSingleTimeReward?: boolean;
    getAddedExtrasLengthForPdf!: number;
    isPageTwoNeededForPdf!: boolean;

    override ngOnInit(): void {
        super.ngOnInit();
        this.addedExtraRewards = this.trsService.getAddedExtrasRewards();
        this.getAddedExtrasLengthForPdf = this.trsService.getUserAddedExtrasLengthForPdf();
        this.isPageTwoNeededForPdf = this.trsService.isAddedExtrasPageTwoNeededForPdf();

        if (this.trsService.isSingleTimeRewardForUser()) {
            this.trsService.getUserTimeRewards().slice(0, 1).forEach((item: TimeReward) => {
                if (this.addedExtraRewards.timeRewards) {
                    this.addedExtraRewards.timeRewards.forEach((reward: AddedExtrasReward) => {
                        const rewardNameLowerCase = reward.type.toLowerCase();
                        const itemNameLowerCase = item.type.toLowerCase();
                        if (rewardNameLowerCase === itemNameLowerCase) {
                            this.addedExtraRewards.categoryRewards.push({
                                name: reward.type.trim().replace(/^\w/, (c) => c.toUpperCase()),
                                categoryRewards: [],
                                timeRewards: [],
                                type: '',
                                shortDescriptionPrint: reward.shortDescriptionPrint,
                                longDescriptionDigital: reward.longDescriptionDigital,
                                categories: ['Lifestyle']
                            });
                        }
                    });
                }
            });
        }

        this.categories = ['All'];
        if (this.addedExtraRewards && this.addedExtraRewards.categoryRewards) {
            this.addedExtraRewards.categoryRewards.forEach((reward: AddedExtrasReward) => {
                (reward.categories || []).forEach((category: string) => {
                    if (this.categories.indexOf(category) === -1) {
                        this.categories.push(category);
                    }
                });
            });
        }
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService!.show(template);
    }

}
